import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] text-white h-screen appheader overflow-y-auto pb-[80px] px-6 py-6" }
const _hoisted_2 = {
  key: 0,
  class: "flex lg:flex-row flex-col bg-[#2B2C32] rounded-xl"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "p-3 mb-24 bg-[#2B2C32] border-0 rounded-lg" }
const _hoisted_5 = { class: "mb-3 flex justify-between" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "input-wrapper mb-3" }
const _hoisted_8 = { class: "flex items-center cursor-pointer xl:mt-2" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "py-2 grid gap-4 xl:grid-cols-4 grid-cols-1" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "flex flex-row justify-between mt-1" }
const _hoisted_13 = {
  key: 0,
  class: "content-image w-[calc(100%-116px)] h-[100px] my-auto relative"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "text-[#878686] text-sm tracking-wider"
}
const _hoisted_16 = { class: "flex flex-col gap-2" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "flex flex-row justify-between mt-1" }
const _hoisted_19 = {
  key: 0,
  class: "content-image w-[calc(100%-116px)] h-[100px] my-auto relative"
}
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  class: "text-[#878686] text-sm tracking-wider"
}
const _hoisted_22 = { class: "flex flex-col gap-2" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "py-2 grid gap-4 xl:grid-cols-4 grid-cols-1 mt-3" }
const _hoisted_25 = { class: "block rounded bg-gray-black w-full text-sm px-1 py-[6px]" }
const _hoisted_26 = {
  for: "membership_primary_color",
  class: "w-full flex"
}
const _hoisted_27 = ["textContent"]
const _hoisted_28 = { class: "block rounded bg-gray-black w-full text-sm px-1 py-[6px]" }
const _hoisted_29 = {
  for: "membership_secondary_color",
  class: "w-full flex"
}
const _hoisted_30 = ["textContent"]
const _hoisted_31 = { class: "block rounded bg-gray-black w-full text-sm px-1 py-[6px]" }
const _hoisted_32 = {
  for: "membership_accent_color",
  class: "w-full flex"
}
const _hoisted_33 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!
  const _component_file_manager = _resolveComponent("file-manager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.membershipNotActivated && !_ctx.isSuperUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[15] || (_cache[15] = [
          _createElementVNode("div", { class: "w-full" }, [
            _createElementVNode("div", { class: "bg-[#2B2C32] rounded-lg px-8 py-[16px]" }, [
              _createElementVNode("p", { class: "text-center text-theme-red" }, "Loyalty is not setup for your business, please contact Tendy support.")
            ])
          ], -1)
        ]))]))
      : (!_ctx.membershipNotActivated || _ctx.isSuperUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_Nav),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[16] || (_cache[16] = _createElementVNode("h3", { class: "text-[24px] text-white font-semibold" }, "Membership Settings", -1)),
                (_ctx.can_edit_membership_details)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.syncCatalogue())),
                        class: "text-sm mr-2 font-medium tracking-widest text-theme-green py-2 px-4 rounded bg-theme-green text-white hover:bg-theme-darkgreen"
                      }, "SYNC CATALOGUE"),
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loyaltyProgram && _ctx.loyaltyProgram.id) ? _ctx.updateProgramSetting() : _ctx.createProgramSetting())),
                        class: "text-sm font-medium tracking-widest text-theme-green py-2 px-4 rounded bg-white hover:text-white hover:bg-theme-darkgreen"
                      }, "SAVE")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[17] || (_cache[17] = _createElementVNode("label", { class: "text-xs mb-1 mt-0" }, "Status:", -1)),
                _createElementVNode("label", _hoisted_8, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    disabled: !_ctx.isSuperUser,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.is_active) = $event)),
                    class: "hidden peer"
                  }, null, 8, _hoisted_9), [
                    [_vModelCheckbox, _ctx.form.is_active]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (_ctx.form.is_active ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
                  }, null, 2),
                  _createElementVNode("span", {
                    class: _normalizeClass(["ml-2 text-white text-sm font-medium uppercase", _ctx.form.is_active ? 'text-theme-green' : 'text-[#F53333]'])
                  }, _toDisplayString(_ctx.form.is_active ? 'On' : 'Off'), 3)
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: _normalizeClass('input-wrapper ' + (_ctx.form.name.error_type))
                }, [
                  _cache[18] || (_cache[18] = _createElementVNode("label", {
                    class: "block text-white text-xs mb-1",
                    for: "name"
                  }, "Name", -1)),
                  _withDirectives(_createElementVNode("input", {
                    onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateFields(['name']))),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.name.value) = $event)),
                    class: "block rounded w-full border-none py-2.5 bg-[#464851] text-white leading-tight focus:outline-none focus:shadow-outline text-sm",
                    placeholder: "Loyalty Program Name",
                    type: "text"
                  }, null, 544), [
                    [_vModelText, _ctx.form.name.value]
                  ]),
                  (_ctx.form.name.error_message)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "field-error label-text mt-1",
                        textContent: _toDisplayString(_ctx.form.name.error_message)
                      }, null, 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", null, [
                  _createVNode(_component_file_manager, {
                    modelValue: _ctx.form.logo_url,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.logo_url) = $event)),
                    classes: "bg-white text-[#2BA66B] px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest",
                    label: "SELECT"
                  }, {
                    custom: _withCtx(({ onClick }) => [
                      _createElementVNode("div", _hoisted_12, [
                        (_ctx.form.logo_url)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createElementVNode("img", {
                                class: "p-1 min-w-[50px] min-h-[50px] w-full",
                                src: _ctx.form.logo_url
                              }, null, 8, _hoisted_14)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_15, "Select Logo")),
                        _createElementVNode("div", _hoisted_16, [
                          (_ctx.can_edit_membership_details)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: onClick,
                                class: "h-9 w-[100px] text-center bg-white text-[#2BA66B] hover:bg-[#2BA66B] hover:text-white px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest"
                              }, _toDisplayString(_ctx.form.logo_url ? 'CHANGE' : 'SELECT'), 9, _hoisted_17))
                            : _createCommentVNode("", true),
                          (_ctx.can_edit_membership_details)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearLogo && _ctx.clearLogo(...args))),
                                class: "h-9 w-[100px] text-center bg-white text-[#2BA66B] hover:bg-[#2BA66B] hover:text-white px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest"
                              }, "CLEAR"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_file_manager, {
                    modelValue: _ctx.form.card_background_image,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.card_background_image) = $event)),
                    classes: "bg-white text-[#2BA66B] px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest",
                    label: "SELECT1"
                  }, {
                    custom: _withCtx(({ onClick }) => [
                      _createElementVNode("div", _hoisted_18, [
                        (_ctx.form.card_background_image)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("img", {
                                class: "p-1 min-w-[50px] min-h-[50px] w-full",
                                src: _ctx.form.card_background_image
                              }, null, 8, _hoisted_20)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_21, "Select Background")),
                        _createElementVNode("div", _hoisted_22, [
                          (_ctx.can_edit_membership_details)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: onClick,
                                class: "h-9 w-[100px] text-center bg-white text-[#2BA66B] hover:bg-[#2BA66B] hover:text-white px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest"
                              }, _toDisplayString(_ctx.form.card_background_image ? 'CHANGE' : 'SELECT'), 9, _hoisted_23))
                            : _createCommentVNode("", true),
                          (_ctx.can_edit_membership_details)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clearBackground && _ctx.clearBackground(...args))),
                                class: "h-9 w-[100px] text-center bg-white text-[#2BA66B] hover:bg-[#2BA66B] hover:text-white px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest"
                              }, "CLEAR"))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", {
                  class: _normalizeClass('input-wrapper' + (_ctx.form.primary_color.error_type))
                }, [
                  _cache[19] || (_cache[19] = _createElementVNode("label", { class: "block text-white text-xs" }, "Primary Color", -1)),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("label", _hoisted_26, [
                      _withDirectives(_createElementVNode("input", {
                        class: "w-6 bg-transparent rounded",
                        onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.validateFields(['primary_color']))),
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.primary_color.value) = $event)),
                        id: "membership_primary_color",
                        type: "color"
                      }, null, 544), [
                        [_vModelText, _ctx.form.primary_color.value]
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass('pl-2 items-center flex ' + (_ctx.form.primary_color.value ? 'text-white': 'text-theme-878686'))
                      }, _toDisplayString(_ctx.form.primary_color.value ? _ctx.form.primary_color.value : '-- Select --'), 3)
                    ])
                  ]),
                  (_ctx.form.secondary_color.error_message)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "field-error label-text mt-1",
                        textContent: _toDisplayString(_ctx.form.secondary_color.error_message)
                      }, null, 8, _hoisted_27))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass('input-wrapper' + (_ctx.form.secondary_color.error_type))
                }, [
                  _cache[20] || (_cache[20] = _createElementVNode("label", { class: "block text-white text-xs" }, "Secondary Color", -1)),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("label", _hoisted_29, [
                      _withDirectives(_createElementVNode("input", {
                        class: "w-6 bg-transparent rounded",
                        onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validateFields(['secondary_color']))),
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.secondary_color.value) = $event)),
                        id: "membership_secondary_color",
                        type: "color"
                      }, null, 544), [
                        [_vModelText, _ctx.form.secondary_color.value]
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass('pl-2 items-center flex ' + (_ctx.form.secondary_color.value ? 'text-white': 'text-theme-878686'))
                      }, _toDisplayString(_ctx.form.secondary_color.value ? _ctx.form.secondary_color.value : '-- Select --'), 3)
                    ])
                  ]),
                  (_ctx.form.secondary_color.error_message)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "field-error label-text mt-1",
                        textContent: _toDisplayString(_ctx.form.secondary_color.error_message)
                      }, null, 8, _hoisted_30))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass('input-wrapper' + (_ctx.form.accent_color.error_type))
                }, [
                  _cache[21] || (_cache[21] = _createElementVNode("label", { class: "block text-white text-xs" }, "Accent Color", -1)),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("label", _hoisted_32, [
                      _withDirectives(_createElementVNode("input", {
                        class: "w-6 bg-transparent rounded",
                        onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.validateFields(['accent_color']))),
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.accent_color.value) = $event)),
                        id: "membership_accent_color",
                        type: "color"
                      }, null, 544), [
                        [_vModelText, _ctx.form.accent_color.value]
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass('pl-2 items-center flex ' + (_ctx.form.accent_color.value ? 'text-white': 'text-theme-878686'))
                      }, _toDisplayString(_ctx.form.accent_color.value ? _ctx.form.accent_color.value : '-- Select --'), 3)
                    ])
                  ]),
                  (_ctx.form.accent_color.error_message)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "field-error label-text mt-1",
                        textContent: _toDisplayString(_ctx.form.accent_color.error_message)
                      }, null, 8, _hoisted_33))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
  ]))
}